import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingState',
  setup(__props) {

// No props or logic needed for this simple component

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "text-center" }, [
      _createElementVNode("div", { class: "animate-spin w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full mx-auto mb-4" }),
      _createElementVNode("p", { class: "text-gray-600 dark:text-gray-300" }, "Loading wallpaper...")
    ], -1)
  ])))
}
}

})